import { applicationsStore } from './applicationsStore'
import { fetchApplications } from 'api/applications'

let inflight = null

export async function ensureApplicationsLoaded({ force = false } = {}) {
	if (!force && applicationsStore.applications?.length > 0) {
		return applicationsStore.applications
	}

	if (inflight) {
		return inflight
	}

	inflight = (async () => {
		try {
			const response = await fetchApplications()
			const applications = response?.applications || []
			applicationsStore.setApplications(applications)
			return applications
		} catch (error) {
			console.error('Error loading applications:', error)
			throw error
		} finally {
			inflight = null
		}
	})()

	return inflight
}
